import {MC_Device} from "../common/iot/MC_Device";
import {O2Device} from "./devices/O2Device";
import {GasMonitor} from "./devices/gas/GasMonitor";

// Class to define what devices can be created
export interface CustomDevice {
    rawType: string,
    fullTypeName: string,
    description: string
}
// Create device
export class CustomDeviceFactory {

    // Devices
    public static TYPE_O2: string = "O2";
    public static TYPE_TOXIC_GAS: string = "GAS";
    public static FULL_TYPE_O2: string = "Oxygen Monitor (UART)";
    public static FULL_TYPE_TOXIC_GAS: string = "Gas 4-20mA Monitor";

    public static SUPPORTED_DEVICES: CustomDevice[] = [

        {
            rawType: this.TYPE_TOXIC_GAS,
            fullTypeName: this.FULL_TYPE_TOXIC_GAS,
            description: ""
        },
        {
            rawType: this.TYPE_O2,
            fullTypeName: this.FULL_TYPE_O2,
            description: ""
        },
    ];

    public static fromData(data: any): MC_Device {
        const type: string | null = (data[MC_Device.FIELD_TYPE] != null)
            ? data[MC_Device.FIELD_TYPE] as string
            : null
        ;
        if (type == null) {
            throw "Missing device type";
        }
        // Custom device types
        switch (type) {
            case this.TYPE_O2:
                return new O2Device(data);
            case this.TYPE_TOXIC_GAS:
                return new GasMonitor(data);
        }
        // Return base device as default
        return new MC_Device(data);
    }

    public static getArrayFromData(dataArray: any[]): MC_Device[] {
        let devices: MC_Device[] = [];
        for (let i = 0; i < dataArray.length; i++) {
            try {
                devices = devices.concat(this.fromData(dataArray[i]));
            } catch (e) {
                console.error("Device parse err: " + e + ": " + JSON.stringify(dataArray[i]));
            }
        }
        return devices;
    }

    public static getFullDeviceType(type: string): string {
        switch (type) {
            case this.TYPE_O2: return this.FULL_TYPE_O2;
            case this.TYPE_TOXIC_GAS: return this.FULL_TYPE_TOXIC_GAS;
        }
        return "Unknown";
    }

}
